<div class="d-flex flex-column gap-2">
  <div
    class="p-0 text-decoration-none d-flex gap-2 align-items-center justify-content-between text-start"
    [class.mb-2]="isCollapsed"
    (click)="toggleCollapsed()"
    [attr.aria-expanded]="!isCollapsed"
  >
    <span class="d-flex gap-2 align-items-center">
      <span isDemoEnabled *ngIf="providerInfo$ | async; let providers">
        {{ providers.provider2 }}
      </span>
    </span>
    <div class="d-flex gap-2 align-items-center">
      <span class="fs-2xs mx-1">{{ selectedLayerCount }} / {{ allLayerCount }}</span>
      <span class="rb-ic rb-ic-down fs-lg" [class.rotate-180]="isCollapsed"></span>
    </div>
  </div>
  <div class="d-flex flex-wrap column-gap-4 justify-content-start" [class.d-none]="isCollapsed">
    <app-layer-control-item
      description="Accidents"
      [isLayerVisibile]="isAccidentsLayerVisible"
      [layerId]="layerIds.Provider2Accidents.name"
      icon="car-crash"
      (visibilityToggled)="toggleLayerVisbility($event)"
    ></app-layer-control-item>
    <app-layer-control-item
      description="BDV"
      [isLayerVisibile]="isBdvVisible"
      [layerId]="layerIds.Provider2Bdv.name"
      icon="car-mechanic"
      (visibilityToggled)="toggleLayerVisbility($event)"
    ></app-layer-control-item>
    <app-layer-control-item
      description="CS"
      [isLayerVisibile]="isConstructionSiteVisible"
      [layerId]="layerIds.Provider2ConstructionSites.name"
      icon="construction"
      (visibilityToggled)="toggleLayerVisbility($event)"
    ></app-layer-control-item>
  </div>
</div>
